// Tonight's moon as a drawing, shared by the day strip and the masthead's
// moon dial. Both take the brief's weatherDetails.moon, which SunCalc
// computes: a phase name and the lit percentage.

// Lit on the right while waxing, the left while waning; full and new look
// the same either way.
export function isWaxing(phase) {
  return !/waning|last/.test(String(phase || ''));
}

// The lit part of the moon for an illuminated fraction f: the outer arc on the
// lit side, then the terminator back as an ellipse that bulges into the dark
// side past half (gibbous) and into the lit side before it (crescent).
export function moonLitPath(cx, cy, r, f, waxing) {
  const rx = Math.abs(1 - 2 * f) * r;
  const outer = waxing ? 1 : 0;
  const term = f > 0.5 ? (waxing ? 1 : 0) : waxing ? 0 : 1;
  return `M ${cx} ${cy - r} A ${r} ${r} 0 0 ${outer} ${cx} ${cy + r} A ${rx.toFixed(2)} ${r} 0 0 ${term} ${cx} ${cy - r} Z`;
}
